import { render, staticRenderFns } from "./PayslipPreferences.vue?vue&type=template&id=59dce2b4&scoped=true"
import script from "./PayslipPreferences.vue?vue&type=script&lang=js"
export * from "./PayslipPreferences.vue?vue&type=script&lang=js"
import style0 from "./PayslipPreferences.vue?vue&type=style&index=0&id=59dce2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dce2b4",
  null
  
)

export default component.exports